import React from 'react'
import DashboardCom from '../../components/Dashboard/DashboardCom'

const Dashboard = () => {
  return (
    <>
    <DashboardCom/>
    </>
  )
}

export default Dashboard